import React from 'react'
import PropTypes from 'prop-types'
// import dynamic from 'next/dynamic'
// import { useRouter } from 'next/router'

// import { addAdsInsideParagraph, addEditorAds } from '@shared-submodule/utils'
import InnerHTML from '@shared/components/InnerHTML'
// import { refreshGoogleAds } from '@shared/libs/ads'

// const Ads = dynamic(() => import('@shared/components/ads'), { ssr: false })

const InfoBlock = props => {
  // const router = useRouter()
  // const isGlanceView = checkIsGlanceView(router?.query)
  // useEffect(async () => {
  //   const ReactDOM = (await import('react-dom'))
  //   if (!isGlanceView) {
  //     if (document.getElementById('gt-ads-1')) { // Editor ads one
  //       ReactDOM.render(<Ads
  //         id="div-ad-gpt-138639789-1660131756-0"
  //         adIdDesktop="oneturf2022_Desktop_AP_MID3_728x90"
  //         adIdMobile="oneturf2022_Mobile_AP_MID3_300x250"
  //         dimensionDesktop={[728, 90]}
  //         dimensionMobile={[300, 250]}
  //         mobile
  //         className={'text-center'}
  //       />, document.getElementById('gt-ads-1'))
  //     }
  //     if (document.getElementById('gt-ads-2')) { // Editor ads Two
  //       ReactDOM.render(<Ads
  //         id="div-ad-gpt-138639789-1660131756-1"
  //         adIdDesktop="oneturf2022_Desktop_AP_MID4_728x90"
  //         adIdMobile="oneturf2022_Mobile_AP_MID4_300x250"
  //         dimensionDesktop={[728, 90]}
  //         dimensionMobile={[300, 250]}
  //         mobile
  //         className={'text-center'}
  //       />, document.getElementById('gt-ads-2'))
  //     }
  //     // if (document.getElementById('video-ads')) { // Video ads after 1st paragraph
  //     //   ReactDOM.render(<Ads
  //     //     id="div-ad-desk-138639789-1660131489-0"
  //     //     adIdDesktop="oneturf2022_Inread_1x1"
  //     //     dimensionDesktop={[1, 1]}
  //     //     className={'text-center'}
  //     //   />, document.getElementById('video-ads'))
  //     // }
  //     refreshGoogleAds()
  //   }
  // }, [])
  return (
    <section className={props.isCommonBox && 'common-box'}>
      <p className={`${props?.fantasystyles?.itemTitle}`}>{props?.title}</p>
      <InnerHTML className="" html={props?.info} />
    </section>
  )
}

InfoBlock.propTypes = {
  fantasystyles: PropTypes.object,
  title: PropTypes.string,
  isCommonBox: PropTypes.bool,
  info: PropTypes.any
}

export default InfoBlock
